import { createContext, ReactNode, useContext } from 'react'
import { ParamsType, SetParamsType } from './types'

type ListContextValue = {
	params: ParamsType
	setParams: SetParamsType
}

const ListContext = createContext<ListContextValue | undefined>(undefined)

export function useListContext() {
	const value = useContext(ListContext)
	if (!value) throw new Error('Cannot call useListContext outside of a ListContext provider')
	return value
}

export function ListContextProvider({
	params,
	setParams,
	children,
}: ListContextValue & { children: ReactNode }) {
	return <ListContext.Provider value={{ params, setParams }}>{children}</ListContext.Provider>
}
